import { TemplateRef, ViewChild } from "@angular/core";
import { TemplateModel } from "@fs/models/template.model";
import { Subject } from "rxjs";

export abstract class EstimateBaseComponent {
  @ViewChild('tab1') tab1Ref: TemplateRef<any>;
  @ViewChild('tab2') tab2Ref: TemplateRef<any>;

  subTabs:TemplateModel[] = [];

  protected readonly ngUnsubscribe$ = new Subject();

  constructor() {}

  protected initSubTabs() {
    this.subTabs.push(new TemplateModel(0, 'Estimate Information', this.tab1Ref, true));
    this.subTabs.push(new TemplateModel(1, 'Estimate Details', this.tab2Ref, false));
  }
  
}